<template>
    <div no-body>
      <b-row class="mx-2 my-4">
        <b-col>
          <!-- Booking Detail -->
          <card>
            <!-- Card header -->
            <div slot="header">
              <b-row >
                <b-col cols="6">
                  <h1 class="mb-0">Customer Information</h1>
                </b-col>
                <b-col cols="6" class="text-right">
                  <base-button type="primary" icon size="sm" v-b-toggle.collapse-2>
                    <span class="btn-inner--icon"><i class="fas fa-caret-down"></i></span>
                    <!-- <span class="btn-inner--text">Add</span> -->
                  </base-button>
                </b-col>
              </b-row>
            </div>
            <!-- Card body -->
            <b-collapse visible id=collapse-2>
              <b-row class="customer_info mb-2">
                <b-col>
                    <b-row>
                        <b-col><p>Customer IM2U ID</p></b-col>
                        <b-col class="text-right"><p><b>{{customers.im2u_customer_id}}</b></p></b-col>
                    </b-row>
                    <b-row>
                        <b-col><p>Customer Name</p></b-col>
                        <b-col class="text-right"><p><b>{{customers.customer_name}}</b></p></b-col>
                    </b-row>
                    <b-row>
                        <b-col><p>Customer Email</p></b-col>
                        <b-col class="text-right" lg="auto"><p><b>{{customers.customer_email}}</b></p></b-col>
                    </b-row>
                    <b-row>
                        <b-col><p>Customer NRIC</p></b-col>
                        <b-col class="text-right"><p><b>{{customers.customer_nric}}</b></p></b-col>
                    </b-row>
                </b-col>
                <b-col>
                    <b-row>
                        <b-col><p>Agent Name</p></b-col>
                        <b-col class="text-right"><p><b>{{customers.agent_name}}</b></p></b-col>
                    </b-row>
                    <b-row>
                        <b-col><p>Agent Email</p></b-col>
                        <b-col class="text-right"><p><b>{{customers.agent_email}}</b></p></b-col>
                    </b-row>
                </b-col>
              </b-row>
            </b-collapse>
          </card>
        </b-col>
      </b-row>  
    </div>
  </template>
  
  <script>
    import { Table, TableColumn, Select , Option } from 'element-ui'
    import {LoginURL, clientId, clientSecret, apiDomain, getHeader} from '@/assets/js/config.js'
    import axios from 'axios'
    
    import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
    import customers from './customers'

    export default {
      mixins: [clientPaginationMixin],
      components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
      },
      data() {
        return {
          tableData: [],
          customers,
        }
      },
      created() {
        // this.getCustomerInfo();
      },
      methods: {
        getCustomerInfo()
        {
          axios.get(apiDomain + 'financial_proposal/financial_proposal/' + this.$route.params.financial_proposal_id ,{ headers: getHeader() })
          .then ( response => {
              if (response.status === 200)
              {
                this.customers = response.data.data[0]
              }
          })
          .catch ( error => {
               
              _gNotif.errorFunction(error,null, "Show Customer Income")
          });
        }
      }

    }
  </script>
  <style scoped>
    p {
      font-size: 0.8125rem;
      font-weight: bold;
    }
    .customer_info .row{
      /* padding-bottom: 1rem; */
      border-bottom: 1px solid rgba(34,36,38,.15);
      margin-left: -0.6rem;
      margin-right: -0.6rem;
      margin-top: 0.5rem;
    }
    .customer_info .row p{
      font-size: 0.9rem;
      font-weight: 600;
      margin-bottom: 0.7rem;
    }
  </style>